/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export interface InterpolationConfig {
  start: string;
  end: string;
}

export const DEFAULT_INTERPOLATION_CONFIG: InterpolationConfig = {
  start: '{{',
  end: '}}'
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
